/* eslint-disable import/no-named-as-default-member */
import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import backend from 'i18next-xhr-backend';

import {PUBLIC_URL, TRANSLATIONS_PATH} from '../config/config';

const FALLBACK_LNG = 'en-US';
const DEFAULT_NS = 'freddie_mercury';

export const initI18n = lang => {
  i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(backend)
    .init({
      lng: lang,
      ns: [DEFAULT_NS],
      defaultNS: [DEFAULT_NS],
      fallbackLng: FALLBACK_LNG,
      load: 'currentOnly',
      keySeparator: false, // we do not use keys in form messages.welcome
      interpolation: {
        prefix: '%',
        suffix: '%',
        escapeValue: false, // react already safes from xss
      },
      backend: {
        crossDomain: true,
        loadPath: `${PUBLIC_URL}${TRANSLATIONS_PATH}%lng%/%ns%.json`,
      },
      react: {
        useSuspense: false,
      },
    });
};

export const changeLanguage = lng => i18n.changeLanguage(lng);

export const getLanguage = () => i18n.language;

export const getI18nDateTime = (datetime, locale) => {
  const options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short',
  };
  return new Intl.DateTimeFormat([locale, FALLBACK_LNG], options).format(datetime);
};

export const getFallbackTranslation = (key, namespace = DEFAULT_NS) => {
  return i18n.getResource(FALLBACK_LNG, namespace, key);
};
